import { Injectable } from '@angular/core';
import { ComponentStore } from '@ngrx/component-store';
import { Toast, ToastType } from './toast.model';

interface ToastState {
  toasts: Toast[];
}

@Injectable({ providedIn: 'root' })
export class ToastService extends ComponentStore<ToastState> {
  readonly toasts$ = this.select((state) => state.toasts);

  private readonly addToast = this.updater((state, toast: Toast): ToastState => ({ toasts: [...state.toasts, toast] }));

  private readonly removeToast = this.updater((state, toast: Toast): ToastState => {
    const index = state.toasts.findIndex((t) => t === toast);
    return { toasts: [...state.toasts.slice(0, index), ...state.toasts.slice(index + 1)] };
  });

  constructor() {
    super({ toasts: [] });
  }

  addToastSuccess(message: string, params?: Record<string, string>) {
    this.addToast({ type: 'success', delay: 5000, message, params });
  }

  addToastDanger(message: string, params?: Record<string, string>) {
    this.addToast({ type: 'danger', delay: 5000, message, params });
  }

  addToastInfo(message: string, params?: Record<string, string>) {
    this.addToast({ type: 'gray', delay: 5000, message, params, icon: 'i' });
  }

  addToastCustom(message: string, icon: string) {
    this.addToast({ type: 'gray', delay: 5000, message, icon });
  }

  addStickyToast(message: string, type: ToastType = 'gray') {
    this.addToast({ type, delay: false, message });
  }

  remove(toast: Toast) {
    this.removeToast(toast);
  }
}
